import { render, staticRenderFns } from "./chooseSku.vue?vue&type=template&id=d5a84e8a"
import script from "./chooseSku.vue?vue&type=script&lang=js"
export * from "./chooseSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5a84e8a')) {
      api.createRecord('d5a84e8a', component.options)
    } else {
      api.reload('d5a84e8a', component.options)
    }
    module.hot.accept("./chooseSku.vue?vue&type=template&id=d5a84e8a", function () {
      api.rerender('d5a84e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/components/chooseSku.vue"
export default component.exports